"use strict";

exports.__esModule = true;
exports["default"] = void 0;

function guard(lowerBoundary, upperBoundary, value) {
  return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}

var _default = guard;
exports["default"] = _default;
module.exports = exports.default;